import React, { useRef } from 'react';
import Slider from 'react-slick';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from 'react-router-dom'; // Import Link for navigation
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Departments from '../Departments'; // Adjust the import path accordingly
export default function HomeComprehensiveCare() {
  const sliderRef = useRef(null);
  const settings = {
    centerMode: true,
    centerPadding: '16%',
    slidesToShow: 3,
    infinite: true,
    speed: 500,
    arrows: false, // Hide default arrows
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 3,
          centerPadding: '8%',
        },
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          centerPadding: '5%',
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerPadding: '2%',
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          centerPadding: '0%',
        },
      },
      {
        breakpoint: 668,
        settings: {
          slidesToShow: 1,
          centerPadding: '0%',
        },
      },
    ],
  };

  // Filter to show only a few important departments (e.g., General Medicine, Pulmonology, Pediatrics, Critical Care)
  const importantDepartments = Departments.medical.filter((dept) =>
    ['General Medicine', 'Pulmonology', 'Pediatrics', 'Cardiology', 'Dermatology'].includes(dept.title)
  );

  return (
    <div className="w-full min-h-screen pt-[160px] md:pt-[230px] pb-[62px] md:pb-12">
      <div className="flex justify-center">
        <h2 className=" text-[36px] md:text-[58px] leading-[1.138em] font-heading text-thickGreen mb-[48px] text-center max-w-[684px]">
          MagnAid Solutions for all your Health issues
        </h2>
      </div>

      {/* Slick Carousel */}
      <div className="w-full">
        <Slider ref={sliderRef} {...settings}>
          {importantDepartments.map((card, index) => (
            <div key={index} className="px-4">
              <div className="bg-lightOrange  py-[48px] px-[32px] rounded-[24px]">
                <img src={card.Icon} alt={card.title} className="mb-6" />
                <div className=" font-heading text-[28px] text-thickGreen mb-4">
                  {card.title}
                </div>
                <p className="text-paraGreen text-[20px] font-medium">
                  {card.cardDes}
                </p>
                <Link aria-label={card.title}
                  to={`${card.metaUrl}`} // Convert title to URL-friendly format
                  className="flex gap-3 text-[18px] items-center mt-6 text-thickGreen font-light font-body hover:text-orange transition-all hover:duration-200 hover:font-medium"
                >
                Learn more
                  <ArrowForwardIcon />
                </Link>
              </div>
            </div>
          ))}
        </Slider>
      </div>
      {/* Navigation Arrows Below Carousel */}
      <div className="max-w-[1340px] mx-auto mt-16 flex items-center justify-between p-3 lg:p-0">
        <button aria-label="left"
          onClick={() => sliderRef.current.slickPrev()} 
          className="border-[1.5px] border-thickGreen shadow-md text-thickGreen bg-transparent 
             rounded-full flex justify-center items-center w-28 md:w-16 h-16 text-2xl 
             transition-all transform-gpu hover:bg-thickGreen hover:text-white group"
        >
          <ArrowBackIcon className="text-thickGreen transition-all group-hover:text-white" />
        </button>
        <Link to='/our-medical-services' className="text-thickGreen text-center sm:mx-4 w-full xl:w-[20%] lg:w-1/3 px-6 py-6  lg:mx-0  rounded-full font-medium border hover:bg-orange hover:border-none border-lightGreen bg-transparent flex justify-center items-center  hover:text-white text-[17px] leading-[1.112em]  transition-all duration-300 hover:translate-y-[-3px]">
          Browse all specialities
        </Link>
        <button
          onClick={() => sliderRef.current.slickNext()} aria-label="right"
          className="border-[1.5px] border-thickGreen txe shadow-md text-thickGreen bg-transparent 
             rounded-full flex justify-center items-center w-28 md:w-16 h-16 text-2xl 
             transition-all transform-gpu hover:bg-thickGreen hover:text-white group"
        >
          <ArrowForwardIcon className="text-thickGreen transition-all group-hover:text-white" />
        </button>
      </div>
    </div>
  );
}